import React from "react";
import "../Styles/Feefrequency.css";


export default function Academic() {
    return (
        <div className="academic-container my-4">
            {/* Header */}
            <div className="special-header panel-white-all" style={{width:'615px' , height:'55px'}}>
            <h4 className="page-title">Academic</h4>
            </div>

            {/* Table */}
            <div className="card col-md-6">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}><b>Category Name</b></td>
                                    <td>Academic</td>

                                </tr>
                                <tr>

                                    <td><b>Category Type</b></td>
                                    <td>Fee</td>

                                </tr>
                                <tr>

                                    <td><b>Amount Type</b></td>
                                    <td>Amount</td>
                                   
                                </tr>

                                <tr>

                                    <td><b>Applicable To</b></td>
                                    <td>All</td>
                                   
                                </tr>

                                <tr>

                                    <td><b>Category Status</b></td>
                                    <td>Active</td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
        </div>

    );

}